import React, { ReactNode } from 'react';
import { useAuth } from '../../context/AuthContext';
import { getPartner } from '../../utils/getPathWithPartner';
import Login from '../Login/Login';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * ProtectedRoute component that wraps routes requiring authentication.
 * Shows Login if not authenticated, unless ?partner= is present (partner view bypass).
 * Exception: ?partner=apebond requires login (restricted partner).
 * When partner param is removed, login is required again.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const partner = getPartner();
  const isApebondPartner = partner?.toLowerCase() === 'apebond';
  const canBypassWithPartner = partner && !isApebondPartner;

  if (!isAuthenticated && !canBypassWithPartner) {
    return <Login />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;


